import { renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d75c822")

_pushScopeId("data-v-6d75c822")
const _hoisted_1 = { class: "flex-1" }
const _hoisted_2 = { class: "ml-16" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")

  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: ["user-guide px-16 py-8 br-lg f-md d-f", {'p-r': !_ctx.abs, 'p-a': _ctx.abs}]
      }, [
        _createVNode("p", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            name: "close",
            class: "close",
            onClick: _ctx.gotIt
          }, null, 8, ["onClick"])
        ]),
        _createVNode("span", {
          class: ['anchor', _ctx.anchorPosition],
          style: {left: `${_ctx.anchorAlign}%`}
        }, null, 6)
      ], 2))
    : _createCommentVNode("", true)
})